import { addBusinessDays } from 'date-fns'

import { ContractType } from '@/pages/instruments/new-instrument/constants/contract-types'
import {
  BarrierLegParams,
  ScheduleGenerator,
  ScheduleLeg,
  Strike,
} from '@/pages/instruments/new-instrument/schedule-builders/types'

export type VanillaStructuredOptions = {
  strikes: Strike[]
  currency_id: number
  contract_type: ContractType
  participation_rate: number
  barrier_type: any
  initial_observation_date: Date
  maturity_date: Date
  settlement_cycle: number
  knockdown_input_level: number
}

const buildBarrierLeg = (
  params: Omit<BarrierLegParams<VanillaStructuredOptions>, 'final_leg'>,
): ScheduleLeg => {
  const {
    strike,
    currency_id,
    contract_type,
    barrier_type,
    participation_rate,
    knockdown_input_level,
    initial_observation_date,
    maturity_date,
    settlement_cycle,
  } = params

  return {
    leg_id: 1,
    option_type: 'Barrier Vanilla',
    barrier_type,
    contract_type,
    region_type: 'European',
    currency_id,
    participation_rate,

    strike: strike.value,
    strike_percent: strike.percent,

    initial_observation_date,
    pay_date: addBusinessDays(maturity_date, settlement_cycle),
    start_observation_date: maturity_date,
    end_observation_date: maturity_date,

    instrument_id: strike.underlying_id,
    payoff_barrier_level: knockdown_input_level,
  }
}

export const VanillaStructuredGenerator: ScheduleGenerator<VanillaStructuredOptions> = {
  generate: ({ strikes, ...params }) => {
    const legs: ScheduleLeg[] = []

    for (const strike of strikes) {
      legs.push(buildBarrierLeg({ strike, ...params }))
    }

    return legs
  },
}
